export default {
  rooms: {
    // [presentationId]: { id: [roomId] }
    p01_ako_ucit_dieta: { id: '1' },
    p02_kroky_k_uspechu: { id: '2' },
    p03_vyvin_pohyb: { id: '3' },
    p04_o_odnimani_zodpovednosti: { id: '4' },
    p05_zdrava_strava: { id: '5' },
    p06_koreny_zavislosti: { id: '6' },
    p07_mozek_jsme_my: { id: '7' },
    p08_telo_a_mozek: { id: '8' },
    p09_co_jedia: { id: '9' },
    p10_v_ucitelskych_monterkach: { id: '14' },
    c01_encounter: { id: '10' },
    c02_panelova_diskusia: { id: '11' },
    c03_workshops_sobota: { id: '12' },
    c05_workshops_nedela: { id: '12' },
    c04_pecha_kucha: { id: '13' },
  },
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/addons/chat/presentation.js